exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".secondsDiv {\n  font-weight: bold;\n  padding-bottom: 10px;\n}\n.numberCss {\n  font-size: 18px;\n}\n.iconStyle {\n  margin-right: 10px;\n}\n.delayLabel {\n  padding: 10px 0px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/pages/pointofsale/styles/components/timeDelayComponent.less
// module id = 3126
// module chunks = 0